export class SatDto {
    lancement: '' | 'A valider' | 'Validé' | 'Refusé par LG' | 'Infos non disponibles' | 'Demande Manuelle'
    valideur: string
    dateValidation: string
    launchDate: string
}

export const typeStatus: string[] = ['A valider', 'Validé', 'Refusé par LG', 'Infos non disponibles', 'Demande Manuelle']
